"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTitleText = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
function omitTitleTextProps(propName) {
  switch (propName) {
    case "isHeadingMultiline":
    case "type":
      return false;
    default:
      return true;
  }
}
const StyledTitleText = (0, _styled.default)("span", {
  shouldForwardProp: omitTitleTextProps
})`
    flex: 1 1 auto;
    min-width: 0;
    word-wrap: break-word;
    ${props => !props.isHeadingMultiline && `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `};

    ${_ref => {
  let {
    type
  } = _ref;
  switch (type) {
    case "simple":
      return `
                  margin-top: 3px;
              `;
  }
}}
`;
exports.StyledTitleText = StyledTitleText;
//# sourceMappingURL=TitleText.js.map